import React from "react";
import PropTypes from "prop-types";
import { isNil } from "ramda";
import { connectHits } from "react-instantsearch-dom";

import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import MenuItemPresenter from "presenters/MenuItemPresenter";
import { useHomePage } from "hooks";
import StarringYou from "pages/Home/components/StarringYou";

const AlgoliaSearchResults = ({ featuredEcards, hits }) => {
  const { viewMoreButton } = useHomePage();

  if (hits.length < 1) {
    return null;
  }

  const content = {
    viewMoreText: isNil(viewMoreButton) ? "" : MenuItemPresenter.linkText(viewMoreButton),
    viewMoreUrl: isNil(viewMoreButton) ? "" : MenuItemPresenter.linkTo(viewMoreButton),
    sectionSubHeaderText: isNil(featuredEcards) ? "" : AlgoliaCardsPresenter.title(featuredEcards),
  };

  return <StarringYou items={hits} loading={false} content={content} />;
};

AlgoliaSearchResults.propTypes = {
  featuredEcards: PropTypes.shape(),
  hits: PropTypes.arrayOf(PropTypes.shape()),
};

const SearchResults = connectHits(AlgoliaSearchResults);

export default SearchResults;
